import Image from "next/image";
import Link from "next/link";

interface ErrorPageProps {
  code: number;
  description: string;
  action?: {
    label: string;
    href?: string;
    onClick?: () => void;
  };
}

export default function ErrorPage({ code, description, action }: ErrorPageProps) {
  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center overflow-y-auto p-6">
      <div className="mx-auto w-full max-w-[242px] text-center sm:max-w-[472px]">
        <h1 className="mb-8 text-5xl font-bold text-gray-800 xl:text-7xl">ERROR</h1>

        {code === 404 ? (
          <Image
            src="/images/error/404.svg"
            alt="404"
            width={472}
            height={158}
            className="mx-auto"
            priority
          />
        ) : (
          <div className="flex items-center justify-center py-4">
            <span className="text-[96px] font-bold leading-none text-primary sm:text-[130px]">
              {code}
            </span>
          </div>
        )}

        <p className="mb-6 mt-10 text-base text-gray-700 sm:text-lg">{description}</p>

        {action &&
          (action.href ? (
            <Link
              href={action.href}
              className="inline-flex items-center justify-center rounded-lg border border-gray-300 bg-white px-5 py-3.5 text-sm font-medium text-gray-700 shadow-theme-xs hover:bg-gray-50 hover:text-gray-800 transition"
            >
              {action.label}
            </Link>
          ) : (
            <button
              onClick={action.onClick}
              className="inline-flex items-center justify-center rounded-lg border border-gray-300 bg-white px-5 py-3.5 text-sm font-medium text-gray-700 shadow-theme-xs hover:bg-gray-50 hover:text-gray-800 transition"
            >
              {action.label}
            </button>
          ))}
      </div>

      <p className="absolute bottom-6 left-1/2 -translate-x-1/2 text-center text-sm text-gray-500 whitespace-nowrap">
        &copy; {new Date().getFullYear()} Something Edible
      </p>
    </div>
  );
}
